/* src/app/modules/shared/components/header-column/header-column-product-tag-group/header-column-product-tag-group.component.scss */
app-header-column-product-tag-group {
  display: contents;
}
/*# sourceMappingURL=header-column-product-tag-group.component.css.map */
